/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Mgr_Description_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Describe the reason for this sanction..." |
*
* @param {Sanction_Mgr_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_mgr_description_placeholder = /** @type {((inputs?: Sanction_Mgr_Description_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Mgr_Description_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Décrivez la raison de cette sanction...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Describa el motivo de esta sanción...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Descreva o motivo desta sanção...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrivi il motivo di questa sanzione...")
	return /** @type {LocalizedString} */ ("Describe the reason for this sanction...")
});